/**
 * Rhenus RVK API
 * \"Rhenus RVK user and admin API Definitions\"
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { inject, injectable, named } from "inversify";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { Headers } from "../Headers";
import { HttpResponse } from "../HttpResponse";
import { IAPIConfiguration } from "../IAPIConfiguration";
import { IHttpClient } from "../IHttpClient";

import { JSONaddUserToLocationreturn } from "../model/jSONaddUserToLocationreturn";
import { JSONCustomerProfil } from "../model/jSONCustomerProfil";
import { JSONMyName } from "../model/jSONMyName";
import { Response } from "../model/response";

import { COLLECTION_FORMATS } from "../variables";
import { RvkUserServiceInterface } from "./rvkUser.serviceInterface";

@injectable()
export class RvkUserService implements RvkUserServiceInterface {
  private basePath: string = "http://kubernetes.slsprototyp.de/service/rvk/api";

  constructor(
    @inject(IHttpClient)
    @named("RvkUserService")
    private httpClient: IHttpClient,
    @inject(IAPIConfiguration)
    @named("RvkUserService")
    private APIConfiguration: IAPIConfiguration
  ) {
    if (this.APIConfiguration.basePath) {
      this.basePath = this.APIConfiguration.basePath;
    }
  }

  /**
   * disableUser
   * @param loginName Loginname to disable
   */
  public disableUserUsingGET(
    loginName: string,
    observe?: "body",
    headers?: Headers
  ): Observable<Response>;
  public disableUserUsingGET(
    loginName: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<Response>>;
  public disableUserUsingGET(
    loginName: string,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (loginName == null) {
      throw new Error(
        "Required parameter loginName was null or undefined when calling disableUserUsingGET."
      );
    }

    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "*/*";

    const response: Observable<HttpResponse<Response>> = this.httpClient.get(
      `${this.basePath}/user/disableuser/${encodeURIComponent(
        String(loginName)
      )}`,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as Response)
      );
    }
    return response;
  }

  /**
   * enableUser
   * @param loginName Loginname to enable
   */
  public enableUserUsingGET(
    loginName: string,
    observe?: "body",
    headers?: Headers
  ): Observable<Response>;
  public enableUserUsingGET(
    loginName: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<Response>>;
  public enableUserUsingGET(
    loginName: string,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (loginName == null) {
      throw new Error(
        "Required parameter loginName was null or undefined when calling enableUserUsingGET."
      );
    }

    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "*/*";

    const response: Observable<HttpResponse<Response>> = this.httpClient.get(
      `${this.basePath}/user/enableuser/${encodeURIComponent(
        String(loginName)
      )}`,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as Response)
      );
    }
    return response;
  }

  /**
   * generateNewPassword
   * @param loginname Generate a new password for the given loginName user
   */
  public generateNewPasswordUsingPUT(
    loginname: string,
    observe?: "body",
    headers?: Headers
  ): Observable<JSONaddUserToLocationreturn>;
  public generateNewPasswordUsingPUT(
    loginname: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONaddUserToLocationreturn>>;
  public generateNewPasswordUsingPUT(
    loginname: string,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (loginname == null) {
      throw new Error(
        "Required parameter loginname was null or undefined when calling generateNewPasswordUsingPUT."
      );
    }

    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "*/*";

    const response: Observable<
      HttpResponse<JSONaddUserToLocationreturn>
    > = this.httpClient.put(
      `${this.basePath}/user/generateNewPassword/${encodeURIComponent(
        String(loginname)
      )}`,
      undefined,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map(
          (httpResponse: HttpResponse) =>
            httpResponse.payload as JSONaddUserToLocationreturn
        )
      );
    }
    return response;
  }

  /**
   * getCustomerProfile
   */
  public getCustomerProfileUsingGET(
    observe?: "body",
    headers?: Headers
  ): Observable<JSONCustomerProfil>;
  public getCustomerProfileUsingGET(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONCustomerProfil>>;
  public getCustomerProfileUsingGET(
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "application/json";

    const response: Observable<
      HttpResponse<JSONCustomerProfil>
    > = this.httpClient.get(`${this.basePath}/user/customerProfile`, headers);
    if (observe === "body") {
      return response.pipe(
        map(
          (httpResponse: HttpResponse) =>
            httpResponse.payload as JSONCustomerProfil
        )
      );
    }
    return response;
  }

  /**
   * myName
   */
  public myNameUsingGET(
    observe?: "body",
    headers?: Headers
  ): Observable<JSONMyName>;
  public myNameUsingGET(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONMyName>>;
  public myNameUsingGET(
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "application/json";

    const response: Observable<HttpResponse<JSONMyName>> = this.httpClient.get(
      `${this.basePath}/user/myName`,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as JSONMyName)
      );
    }
    return response;
  }

  /**
   * sendcsv
   */
  public sendcsvUsingGET(observe?: "body", headers?: Headers): Observable<any>;
  public sendcsvUsingGET(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any>>;
  public sendcsvUsingGET(
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "*/*";

    const response: Observable<HttpResponse<any>> = this.httpClient.get(
      `${this.basePath}/user/testsendmail`,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as any)
      );
    }
    return response;
  }

  /**
   * testcsv
   */
  public testcsvUsingGET(observe?: "body", headers?: Headers): Observable<any>;
  public testcsvUsingGET(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any>>;
  public testcsvUsingGET(
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "";

    const response: Observable<HttpResponse<any>> = this.httpClient.get(
      `${this.basePath}/user/testcsv`,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as any)
      );
    }
    return response;
  }

  /**
   * updatecontactperson
   */
  public updatecontactpersonUsingGET(
    observe?: "body",
    headers?: Headers
  ): Observable<any>;
  public updatecontactpersonUsingGET(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any>>;
  public updatecontactpersonUsingGET(
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "";

    const response: Observable<HttpResponse<any>> = this.httpClient.get(
      `${this.basePath}/user/updatecontactperson`,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as any)
      );
    }
    return response;
  }
}
